import React from 'react';
import { MatterFilters as MatterFiltersType } from '../../../types/matters';

interface MatterFiltersProps {
  filters: MatterFiltersType;
  onChange: (filters: Partial<MatterFiltersType>) => void;
}

const MatterFilters: React.FC<MatterFiltersProps> = ({ filters, onChange }) => {
  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'pending', label: 'Pending' },
    { value: 'on_hold', label: 'On Hold' },
    { value: 'closed', label: 'Closed' }
  ];

  const practiceAreaOptions = [
    { value: '', label: 'All Practice Areas' },
    { value: 'Family Law', label: 'Family Law' },
    { value: 'Intellectual Property', label: 'Intellectual Property' },
    { value: 'Estate Planning', label: 'Estate Planning' },
    { value: 'Personal Injury', label: 'Personal Injury' },
    { value: 'Employment Law', label: 'Employment Law' },
    { value: 'Corporate Law', label: 'Corporate Law' },
    { value: 'Real Estate', label: 'Real Estate' },
    { value: 'Criminal Defense', label: 'Criminal Defense' }
  ];

  const attorneyOptions = [
    { value: '', label: 'All Attorneys' },
    // Attorneys will be loaded dynamically from User Management
    // Real attorney data replaces mock data as part of production integration
  ];

  const handleFilterChange = (key: keyof MatterFiltersType, value: string) => {
    onChange({ [key]: value || '' });
  };

  const hasActiveFilters = filters.status || filters.practice_area || filters.assigned_attorney_id;

  return (
    <div className="flex flex-row items-center gap-3">
      {/* Status Filter */}
      <div className="min-w-40">
        <select
          value={filters.status || ''}
          onChange={(e) => handleFilterChange('status', e.target.value)}
          className="block w-full h-10 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 text-sm"
        >
          {statusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Practice Area Filter */}
      <div className="min-w-48">
        <select
          value={filters.practice_area || ''}
          onChange={(e) => handleFilterChange('practice_area', e.target.value)}
          className="block w-full h-10 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 text-sm"
        >
          {practiceAreaOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Attorney Filter */}
      <div className="min-w-40">
        <select
          value={filters.assigned_attorney_id || ''}
          onChange={(e) => handleFilterChange('assigned_attorney_id', e.target.value)}
          className="block w-full h-10 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 text-sm"
        >
          {attorneyOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <button
          onClick={() => onChange({ status: '', practice_area: '', assigned_attorney_id: '', search: '' })}
          className="px-3 py-2 h-10 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors whitespace-nowrap"
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default MatterFilters;
